import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { interceptShareTarget } from './share';
import './tokens.css';
import './index.css';

interceptShareTarget();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is best-effort — the app works without it.
    });
  });
}
